// imports for main view components that wrap over other sub-components go here

import RootView, {
  wrapComponentWithRootView,
  wrapComponentWithProvider
} from "./root-view/RootView";
import ABTestPage, { Page } from "./page/Page";
import ScrollToTop from "./scroll-to-top/ScrollToTop";
import RoutingSubscriber from "./routing-subscriber/RouterSubscriber";
import routingSubscriberReducer from "./routing-subscriber/reducers/router-subscriber";

const containers = {
  root: {
    rootView: RootView,
    wrapComponentWithRootView,
    wrapComponentWithProvider
  },
  Page,
  ABTestPage,
  routingSubscriber: {
    RoutingSubscriber,
    routingSubscriberReducer
  },
  ScrollToTop
};

export default containers;
